import React from "react";
import { ReportContext } from "../contexts/ReportProvider";

export const useReport = () => React.useContext(ReportContext);
